import { MetaDefinition } from '@angular/platform-browser';
import { LinkDefinition } from '@routing/canonical-urls';
import { LinkRel } from '@routing/directories/directories-routing.enum';

/* eslint-disable */

export const Links: LinkDefinition[] = [
  {
    rel: LinkRel.Author,
    href: 'https://plus.google.com/+Wizbii',
  },
  {
    rel: LinkRel.Publisher,
    href: 'https://plus.google.com/+Wizbii',
  },
];

export const Metas: MetaDefinition[] = [
  {
    name: 'robots',
    content: 'index,follow',
  },
  {
    name: 'twitter:card',
    content: 'summary_large_image',
  },
  {
    name: 'twitter:site',
    content: '@Wizbii',
  },
  {
    name: 'twitter:creator',
    content: '@Wizbii',
  },
  {
    property: 'og:type',
    content: 'profile',
  },
  {
    property: 'og:site_name',
    content: 'Wizbii.com',
  },
];
